import { render } from "./sidebar-four.vue?vue&type=template&id=5f881470"
import script from "./sidebar-four.vue?vue&type=script&lang=js"
export * from "./sidebar-four.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__